import { render, staticRenderFns } from "./ARegDocentes.vue?vue&type=template&id=254a28b6"
import script from "@/components/docentes-add.js?vue&type=script&lang=js&external"
export * from "@/components/docentes-add.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports